import React from 'react';

function StatIncrement({ name, value, increase, increaseStat, decreaseStat, tooltip }) {
    return (
        <div className="create-statbox" data-tooltip={tooltip}>
            <div className="stat-item key">{name}</div>
            <div className="stat-value">{value + (increase || 0)}</div>
            <div className="stat">+{increase}</div>
            <div className="stat-controls">
                <button
                    className="stat-button"
                    onClick={() => decreaseStat(name)}
                    disabled={!increase}
                >
                    -
                </button>
                <button
                    className="stat-button"
                    onClick={() => increaseStat(name)}
                >
                    +
                </button>
            </div>
        </div>
    );
}

export default StatIncrement; 